import { render } from "./training-icon.svg?vue&type=template&id=60f9b1f2"
import script from "./training-icon.svg?vue&type=script&lang=js"
export * from "./training-icon.svg?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src279/src/s3/00/src/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__